"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PREVIEW_SEE_ALL_RESULTS = exports.SEARCH_PREVIEW = exports.QUERY_NAME = exports.POPULAR_NUMBER_OF_PRODUCTS = exports.MAX_SEARCH_HEIGHT = exports.BESTSELLERS_PATH = void 0;
const SEARCH_PREVIEW = exports.SEARCH_PREVIEW = 'search-preview';
const SEARCH_PREVIEW_SEE_ALL_RESULTS = exports.SEARCH_PREVIEW_SEE_ALL_RESULTS = 'search-preview-see-all-results';
const MAX_SEARCH_HEIGHT = exports.MAX_SEARCH_HEIGHT = 630;
const QUERY_NAME = exports.QUERY_NAME = 'query';
const BESTSELLERS_PATH = exports.BESTSELLERS_PATH = '/bestsellers';
const POPULAR_NUMBER_OF_PRODUCTS = exports.POPULAR_NUMBER_OF_PRODUCTS = 3;
